import { CacheLocation } from '@auth0/auth0-spa-js';

const cacheLocation: CacheLocation = 'localstorage';

const AUTH0_AUDIENCE = 'https://twinlytix-dev.us.auth0.com/api/v2/';

const auth0 = {
  domain: 'twinlytix-dev.us.auth0.com',
  clientId: 'F3RcETrVsNm7KE8MehKHHGrRxQ32w3fY',
  cacheLocation,
   useRefreshTokens: true,
  useRefreshTokensFallback: false,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: AUTH0_AUDIENCE,
    // Include ALL scopes upfront so refresh token has permission for all operations
    scope: 'openid profile email offline_access read:current_user read:data write:data'
  },
  httpInterceptor: {
    allowedList: [
      {
        uri: 'https://gawerglfemgcjrbhtcuy.supabase.co/functions/v1/*',
        tokenOptions: {
          authorizationParams: {
            audience: AUTH0_AUDIENCE
            // Scopes inherited from refresh token - no need to specify here
          }
        }
      }
    ]
  }
};

export const environment = {
  production: false,
  apiUrl: 'https://gawerglfemgcjrbhtcuy.supabase.co/functions/v1',
  auth0,
  enableDebug: true,
  version: '1.0.0-dev',
  adminEmails: ['fabio+10@fantix.ai', 'fabio+22@fantix.ai', 'filippo@fantix.ai', 'antonio@fantix.ai', 'kcundari@fantix.ai', 'igaydos@fantix.ai', 'luca@fantix.ai']
};